import React, { useEffect } from 'react';
import DatePicker from 'antd/lib/date-picker';
import { Typography } from 'antd';
import dayjs from 'dayjs';
import { ArrowRightOutlined } from '@ant-design/icons';

const { Text } = Typography;
const { RangePicker } = DatePicker;

//rest here will need options value
//option should in this format: {label: A, value: B}
const RangePickerFieldAntd = ({ input, meta, format, errorText, ...rest }) => {
  useEffect(() => {
    if (rest?.renderFields) {
      rest.renderFields(input, rest?.valuesData);
    }
  }, [rest?.valuesData]);

  return (
    <>
      <RangePicker
        separator={<ArrowRightOutlined />}
        {...input}
        {...rest}
        value={
          input.value
            ? input.value.length == 2
              ? [dayjs(input.value[0]), dayjs(input.value[1])]
              : [dayjs(input.value[0]), '']
            : ['', '']
        }
        format="YYYY/MM/DD"
        onChange={(valueChange) => input.onChange(valueChange)}
      />
      {meta.error && meta.touched ? (
        <Text type="danger">
          {errorText[meta.error] ? errorText[meta.error] : meta.error}
        </Text>
      ) : null}
    </>
  );
};

export default RangePickerFieldAntd;
